import clsx from "clsx";
import Pattern from "public/ui-elements/banner-pattern.svg";

import { BannerPhoto } from "@shared/ui/banner-photo";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Icon } from "@shared/ui/icon";
import { Body, Heading } from "@shared/ui/typography";

import type { BannerSectionBase } from "../model/types";

import s from "./banner.module.scss";

export const Banner = ({
  icon,
  title,
  description,
  photo,
  buttonText,
  buttonLink,
}: BannerSectionBase) => {
  const hasDescription = Boolean(description);
  const hasPhoto = Boolean(photo);

  return (
    <section className={clsx(s.root, hasDescription && s.withDescription)}>
      <div className={s.content}>
        <div className={s.header}>
          {icon?.name && !description && <Icon name={icon.name} size={16} />}
          {title && (
            <Heading level={description ? 5 : 6} tag="h2" className={s.text}>
              {title}
            </Heading>
          )}
          {description && <Body className={s.description}>{description}</Body>}
        </div>

        {buttonText && buttonLink && (
          <ButtonWithIcon
            className={s.button}
            iconName={icon?.name || "three-circle"}
            iconFillColor="violet"
            href={buttonLink}
            variant="primary-light"
          >
            {buttonText}
          </ButtonWithIcon>
        )}
      </div>

      {hasPhoto && photo && (
        <BannerPhoto
          photoSrc={photo.url || ""}
          photoAlt={photo.alternativeText || title}
          className={s.bannerPhoto}
        />
      )}

      {!hasPhoto && (
        <div className={s.pattern}>
          <Pattern />
        </div>
      )}
    </section>
  );
};
